var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_vm._v(" This is a work in progress, there is just one useful thing here: "),_c('router-link',{attrs:{"to":"/brasspire/ledger"}},[_vm._v("Darrynt Cauladra's Flower Ledger")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }